import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  DEFAULT_DRAG_STYLE,
  DRAG_DROP_DATA_ATTR,
  DRAG_DROP_INTERACTION_STYLE,
  DRAGGING_STYLE,
} from '../DragDrop.constants'

// With `withDragHandle` the item itself is not draggable: `children` is a
// render function that receives the drag-handle props to spread on the grip.
function DragDropSortableItem({
  children,
  draggingStyle,
  id,
  sortableProps = EMPTY_OBJECT,
  style = EMPTY_OBJECT,
  withDragHandle = false,
  ...restProps
}) {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id, ...sortableProps })

  const dragProps = { ...attributes, ...listeners }

  // The sortable re-renders on every pointer move while dragging; the content
  // is rebuilt only when the handle props change, so the subtree bails out.
  const content = withDragHandle ? children(dragProps) : children

  const itemStyle = {
    ...style,
    ...(withDragHandle
      ? null
      : { ...DRAG_DROP_INTERACTION_STYLE, ...DEFAULT_DRAG_STYLE }),
    ...(isDragging
      ? {
          ...(withDragHandle ? null : DRAGGING_STYLE),
          ...draggingStyle,
        }
      : null),
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      {...(withDragHandle ? null : dragProps)}
      {...restProps}
      {...{
        [DRAG_DROP_DATA_ATTR.isDragging]: isDragging,
        [DRAG_DROP_DATA_ATTR.isSorting]: isSorting,
      }}
      ref={setNodeRef}
      style={itemStyle}
    >
      {content}
    </div>
  )
}

export default DragDropSortableItem
